/** Newest mail first (sent_at desc, then id desc). */
export function sortMailThreadNewestFirst(messages) {
  return [...(Array.isArray(messages) ? messages : [])].sort((a, b) => {
    const ta = Date.parse(a?.sent_at) || 0;
    const tb = Date.parse(b?.sent_at) || 0;
    if (tb !== ta) return tb - ta;
    return String(b?.id ?? "").localeCompare(String(a?.id ?? ""), "en");
  });
}

export function graphMessageIdFromComm(comm) {
  if (!comm || typeof comm !== "object") return "";
  const meta = comm.metadata && typeof comm.metadata === "object" ? comm.metadata : {};
  return String(
    comm.graph_message_id || meta.graph_message_id || meta["graph_message_id"] || ""
  ).trim();
}

/** Match CompanyAiMailboxMessageReaderDialog Innhold body selection. */
export function mailBodyFromGraphMessage(message) {
  if (!message) return { html: "", text: "" };
  if (message.body_content_type === "html" && message.body_content) {
    return { html: message.body_content, text: "" };
  }
  return {
    html: "",
    text: message.body_content || message.body_preview || "",
  };
}


/** Keep all saved conversations visible; mailbox is part of a thread's identity. */
export function groupCaseMailThreads(messages) {
  const groups = new Map();
  const list = Array.isArray(messages) ? messages : [];
  const mailboxes = new Map();
  list.forEach((message) => {
    if (!message.conversation_id || !message.mailbox_email) return;
    const addresses = mailboxes.get(message.conversation_id) || new Set();
    addresses.add(message.mailbox_email.trim().toLowerCase());
    mailboxes.set(message.conversation_id, addresses);
  });
  sortMailThreadNewestFirst(list).forEach((message) => {
    // Legacy auto-replies omitted mailbox. Infer it only when the saved
    // conversation has exactly one mailbox; ambiguous histories stay separate.
    const known = mailboxes.get(message.conversation_id);
    const mailbox = message.mailbox_email?.trim().toLowerCase() ||
      (known?.size === 1 ? [...known][0] : "");
    const key = JSON.stringify([mailbox, message.conversation_id || `message-${message.id}`]);
    if (!groups.has(key)) {
      groups.set(key, { key, mailboxEmail: mailbox, conversationId: message.conversation_id, messages: [] });
    }
    groups.get(key).messages.push(message);
  });
  return [...groups.values()];
}
